/*
 * -----------------------------------------------------------------------
 *  <copyright file="menu-button.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, MenuItem, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import React, { useState } from 'react';
import { useTranslation } from '../../../../hooks';

const MenuButton = ({ icon, items, item }: any) => {
    const [anchor, setAnchor] = useState(null);
    const { t } = useTranslation();

    return (
        <>
            <IconButton
                aria-owns={anchor ? 'menu-appbar' : null}
                aria-haspopup="true"
                onClick={(e: any) => {
                    setAnchor(e.currentTarget);
                    e.stopPropagation();
                }}
                size="large"
            >
                <FontAwesomeIcon icon={icon} style={{ marginRight: 10 }} />
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchor}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchor)}
                onClose={(e: any) => {
                    setAnchor(null);
                    e.stopPropagation();
                }}
            >
                {(items || []).map((i: any) => (
                    <MenuItem
                        disabled={i.disabled}
                        key={i.text}
                        onClick={(e: any) => {
                            if (!i.disabled) {
                                i.handler(item);
                                setAnchor(null);
                                e.stopPropagation();
                            }
                        }}
                    >
                        {Boolean(i.icon) && <FontAwesomeIcon icon={['fal', i.icon]} style={{ marginRight: 10 }} />}
                        <Typography variant="body2">{t(i.text)}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default MenuButton;
